import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MyDeqErrorHandler } from "../../../core/errorHandler";
import { AppService } from "../../../service/app.service";
import { Utils } from "../../../shared/Utils";

@Component({
  selector: "approved-list",
  templateUrl: "./approved-list.component.html",
})
export class ApprovedListComponent implements OnInit {
  permits: any[] = [];
  errorsList: any[] = [];
  displayBackButton: boolean = false;
  /** Where the Return button should go — search-criteria (View All) or back to search-criteria always */
  fromPage: string = "search-criteria";

  constructor(
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private errorHandler: MyDeqErrorHandler,
    public utils: Utils,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Read query params — may contain search criteria (specific search) or none (View All).
    // Ignore 'from*' params — those are only used by search-result to navigate back.
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const paramMap = new Map<string, string>();
      if (queryParams["ltfid"])          paramMap.set("ltfid",          queryParams["ltfid"]);
      if (queryParams["companyname"])    paramMap.set("companyname",    queryParams["companyname"]);
      if (queryParams["facilityname"])   paramMap.set("facilityname",   queryParams["facilityname"]);
      if (queryParams["facilitycounty"]) paramMap.set("facilitycounty", queryParams["facilitycounty"]);

      this.appService
        .getServiceCall(null, paramMap.size > 0 ? paramMap : null, null, "service/permit/cgp")
        .subscribe(
          (response) => {
            this.permits = Array.isArray(response) ? response : [];
            this.displayBackButton = true;
          },
          (error) => {
            this.errorsList = this.errorHandler.getErrors(error);
            this.displayBackButton = true;
          }
        );
    });
  }

  /** Resolve county code to county name using the shared countyMap. */
  getCountyName(countyCode: string): string {
    if (!countyCode) return "";
    return this.utils.countyMap.get(countyCode) || countyCode;
  }

  /** Navigate to the detail (accordion) view for the selected permit. */
  viewDetails(permit: any): void {
    // Capture the current query params (the original search context) so
    // the detail page can pass them back when the user clicks Return to Search.
    this.activatedRoute.queryParams.subscribe((currentParams) => {
      // Build a params object: ltfid for the detail call + original search
      // context encoded as 'fromParams' so Return to Search restores the full list.
      const navParams: any = { ltfid: permit.ltfIdNo };
      // Encode original search params so the detail page can hand them back
      if (currentParams["companyname"])    navParams["fromCompany"]  = currentParams["companyname"];
      if (currentParams["facilityname"])   navParams["fromFacility"] = currentParams["facilityname"];
      if (currentParams["facilitycounty"]) navParams["fromCounty"]   = currentParams["facilitycounty"];
      if (currentParams["ltfid"])          navParams["fromLtfid"]    = currentParams["ltfid"];
      // Flag that we came from approved-list with no filters (View All)
      if (!currentParams["companyname"] && !currentParams["facilityname"] &&
          !currentParams["facilitycounty"] && !currentParams["ltfid"]) {
        navParams["fromViewAll"] = "true";
      }
      this.router.navigate(["/cgp", "search-result"], { queryParams: navParams });
    }).unsubscribe();
  }

  returnToSearch(): void {
    this.router.navigate(["/cgp", "search-criteria"]);
  }
}
